import { AppLayout } from 'layouts';
import type { Event } from 'models';
import type { ReactNode } from 'react';
import { useNodeEventQuery } from '../queries';
import { EventLayoutSkeleton } from './event-layout-skeleton';

type P = {
  children: ({ event }: { event: Event }) => ReactNode;
  eventId: string;
  header: ({ event }: { event: Event }) => ReactNode;
};

const EventLayout = ({ children, eventId, header }: P) => {
  const { data: event, error } = useNodeEventQuery({ eventId }, { throwOnError: false });

  return (
    <AppLayout error={error}>
      {event ? (
        <>
          {header({ event })}
          {children({ event })}
        </>
      ) : (
        <EventLayoutSkeleton />
      )}
    </AppLayout>
  );
};
export default EventLayout;
